import {initializeApp} from 'firebase/app';

import {getFirestore} from 'firebase/firestore';
import {getAuth} from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyAGzm_ddXDa4AG4dzw4tYDqt11vWPyB6Vc',
  authDomain: 'telemed-management.firebaseapp.com',
  projectId: 'telemed-management',
  storageBucket: 'telemed-management.appspot.com',
  messagingSenderId: '777895498030',
  appId: '1:777895498030:web:1b849f1e9b5426861deabf',
  measurementId: 'G-H37W2NGYRY',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
